import { jsx as _jsx } from "react/jsx-runtime";
import { SAutoModal } from "./SAutoModal";
const defaultActions = ({ onCancel, onConfirm, confirmText = "Ok", cancelText })=>[
        {
            title: confirmText,
            onClick: ({})=>{
                return onConfirm();
            }
        },
        ...cancelText ? [
            {
                title: cancelText,
                onClick: ({})=>{
                    return onCancel();
                },
                variant: "secondary"
            }
        ] : []
    ];
export const SConfirmModal = ({ onConfirm, onCancel = ()=>{}, button, confirmText, cancelText, title, children })=>{
    const actions = defaultActions({
        onConfirm,
        onCancel,
        confirmText,
        cancelText
    });
    return /*#__PURE__*/ _jsx(SAutoModal, {
        button: button,
        title: title,
        actions: actions,
        children: children
    });
};
